'use strict';

import MyCartView from './MyCartView';
import CartNotificationView from '../Cart/CartNotificationView';
import ProductQuantityRestrictionModalView from '../Cart/ProductQuantityRestrictionModalView';
import ProductFormModalView from '../Cart/ProductFormModalView';

import * as Features from '../../utilities/featureFlags';

export function createMyCart($parent) {
  if (!Features.EnableAjaxLoadHeader.isEnabled() || $parent.find('#header-cart').length) {
    var cartView = new MyCartView({
      el: '#header-cart'
    });

    if (cartView.$el.length) {
      new CartNotificationView(cartView.$el);
    }

    // Create a product minimum quantity dialog and the product form overlay dialog
    new ProductQuantityRestrictionModalView();
    new ProductFormModalView();
  }
}



// WEBPACK FOOTER //
// ./assets/components/MyCart/MyCart.js